import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activeAdvertisement,
  createAdvertisement,
  deleteAdvertisement,
  getAdvertisement,
  inactiveAdvertisement,
  listAdvertisement,
  updateAdvertisement,
} from 'api/setting/advertisement/advertisement.api';
import {
  ActiveAdvertisementRequestModel,
  DeleteAdvertisementRequestModel,
  GetAdvertisementRequestModel,
  InactiveAdvertisementRequestModel,
  ListAdvertisementRequestModel,
  SaveAdvertisementRequestModel,
} from 'models/setting/advertisement/advertisement.model';

export const getAdvertisementAction = createAsyncThunk(
  'GET_ADVERTISEMENT_REQUEST',
  async (payload: GetAdvertisementRequestModel) => getAdvertisement(payload),
);

export const listAdvertisementAction = createAsyncThunk(
  'LIST_ADVERTISEMENT_REQUEST',
  async (payload: ListAdvertisementRequestModel) => listAdvertisement(payload),
);

export const createAdvertisementAction = createAsyncThunk(
  'CREATE_ADVERTISEMENT_REQUEST',
  async (payload: SaveAdvertisementRequestModel, { rejectWithValue }) => {
    try {
      return await createAdvertisement(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updateAdvertisementAction = createAsyncThunk(
  'UPDATE_ADVERTISEMENT_REQUEST',
  async (payload: SaveAdvertisementRequestModel, { rejectWithValue }) => {
    try {
      return await updateAdvertisement(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deleteAdvertisementAction = createAsyncThunk(
  'DELETE_ADVERTISEMENT_REQUEST',
  async (payload: DeleteAdvertisementRequestModel, { rejectWithValue }) => {
    try {
      return await deleteAdvertisement(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactiveAdvertisementAction = createAsyncThunk(
  'INACTIVE_ADVERTISEMENT_REQUEST',
  async (payload: InactiveAdvertisementRequestModel, { rejectWithValue }) => {
    try {
      return await inactiveAdvertisement(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activeAdvertisementAction = createAsyncThunk(
  'ACTIVE_ADVERTISEMENT_REQUEST',
  async (payload: ActiveAdvertisementRequestModel, { rejectWithValue }) => {
    try {
      return await activeAdvertisement(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
